/**
 * Debounces the callback function by 100ms.
 * @param {Function} fn
 * @returns {(function(*=): void)|*}
 */
export const debounce = (fn) => {
  let timer;

  return (event) => {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(fn, 100, event);
  };
};

/**
 * Adds or removes a class to the body
 * @param {String} className
 * @param {Boolean} isAdded
 */
export const setBodyClass = (className, isAdded) => {
  if (isAdded) {
    document.body.classList.add(className);
  } else {
    document.body.classList.remove(className);
  }
};

/**
 * Validates a form field, depending on its type.
 * @param el
 * @returns {Boolean}
 */
export const validateFormField = (el) => {
  const type = el.dataset.type || el.type;
  const isValid = validateValue(type, el);

  el.classList.toggle('invalid', !isValid);

  return isValid;
};

/**
 * Validates the value of a form field, returns 'true' if it's valid.
 * @param {String} type
 * @param {Element} el
 * @returns {Boolean}
 */
const validateValue = (type, el) => {
  switch (type) {
    case 'email':
      return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        el.value.toLowerCase(),
      );

    case 'checkbox':
      return !!el.checked;

    case 'dealer-id':
      return /^[0-9]{4}\-[A-Z]{2}$/.test(el.value);

    default:
      return !!el.value.length;
  }
};
